module.exports = __webpack_public_path__ + "assets/img/4.39cdafd3.jpg";